import {
  TranslationNamespaceEnum,
  type NamespaceTester,
} from "src/lib/i18next/types.ts";

const namespaceToPathMap = {
  [TranslationNamespaceEnum.RecommendationPanel]: (lang: string) =>
    `src/admin/recommendation/locales/${lang}.json`,
  [TranslationNamespaceEnum.UnexpectedError]: (lang: string) =>
    `src/components/UnexpectedError/locales/${lang}.json`,
  [TranslationNamespaceEnum.AdminLayout]: (lang: string) =>
    `src/admin/layout/locales/${lang}.json`,
  [TranslationNamespaceEnum.ProcessesPanel]: (lang: string) =>
    `src/admin/layout/header/ProcessesPanel/locales/${lang}.json`,
  [TranslationNamespaceEnum.Common]: (lang: string) =>
    `src/locales/${lang}/common.json`,

  [TranslationNamespaceEnum.DashboardPage]: (lang: string) =>
    `src/admin/dashboard/dashboard.${lang}.json`,
  [TranslationNamespaceEnum.NotFoundPage]: (lang: string) =>
    `src/admin/not-found/not-found.${lang}.json`,
  [TranslationNamespaceEnum.LoginPage]: (lang: string) =>
    `src/auth/pages/LoginPage/locales/${lang}/loginPage.json`,
  [TranslationNamespaceEnum.CopyButtonComponent]: (lang: string) =>
    `src/components/CopyButton/CopyButton.${lang}.json`,
  [TranslationNamespaceEnum.DataGridComponent]: (lang: string) =>
    `src/components/DataGrid/DataGrid.${lang}.json`,
  [TranslationNamespaceEnum.DateRangePicker]: (lang: string) =>
    `src/components/DateRangePicker/DateRangePicker.${lang}.json`,
  [TranslationNamespaceEnum.SelectComponent]: (lang: string) =>
    `src/components/Select/locales/${lang}/selectComponent.json`,
  [TranslationNamespaceEnum.AutocompleteComponent]: (lang: string) =>
    `src/components/Autocomplete/autocomplete.${lang}.json`,
  [TranslationNamespaceEnum.ProTabsComponent]: (lang: string) =>
    `src/components/ProTabs/locales/${lang}/proTabsComponent.json`,
  [TranslationNamespaceEnum.InputPlaceholdersComponent]: (lang: string) =>
    `src/components/InputPlaceholders/locales/${lang}.json`,
  [TranslationNamespaceEnum.PaginationComponent]: (lang: string) =>
    `src/components/Pagination/locales/${lang}/paginationComponent.json`,
  [TranslationNamespaceEnum.TextAreaComponent]: (lang: string) =>
    `src/components/TextArea/locales/${lang}/textAreaComponent.json`,
  [TranslationNamespaceEnum.ErrorBoundaryComponent]: (lang: string) =>
    `src/components/ErrorBoundary/locales/${lang}/errorBoundaryComponent.json`,
  [TranslationNamespaceEnum.FileInputComponent]: (lang: string) =>
    `src/components/FileInput/locales/${lang}/fileInputComponent.json`,
  [TranslationNamespaceEnum.DropZoneInputComponent]: (lang: string) =>
    `src/components/DropZoneInput/locales/${lang}/dropZoneInputComponent.json`,
  [TranslationNamespaceEnum.DropZoneInputComponentV2]: (lang: string) =>
    `src/components/DropZoneInputV2/locales/${lang}/dropZoneInputComponent.json`,
  [TranslationNamespaceEnum.CkeditorComponent]: (lang: string) =>
    `src/components/CKEditor5/locales/${lang}.json`,
  [TranslationNamespaceEnum.TransferListComponent]: (lang: string) =>
    `src/components/TransferList/locales/${lang}/transferListComponent.json`,
  [TranslationNamespaceEnum.CommentsFormPanel]: (lang: string) =>
    `src/components/Form/panels/CommentsPanel/CommentsPanel.${lang}.json`,
  [TranslationNamespaceEnum.BillBalance]: (lang: string) =>
    `src/admin/bill/balance/locales/${lang}.json`,
  [TranslationNamespaceEnum.MarketplaceField]: (lang: string) =>
    `src/admin/modules/product/forms/product/shared/MarketplaceField/locales/${lang}.json`,
  [TranslationNamespaceEnum.InternalServerError]: (lang: string) =>
    `src/components/QueryError/components/InternalServerError/locales/${lang}.json`,
  [TranslationNamespaceEnum.TooManyRequests]: (lang: string) =>
    `src/components/QueryError/components/TooManyRequests/locales/${lang}.json`,
  [TranslationNamespaceEnum.Bill]: (lang: string) =>
    `src/admin/bill/locales/${lang}.json`,
  [TranslationNamespaceEnum.BalanceList]: (lang: string) =>
    `src/admin/balance-list/locales/${lang}.json`,
  [TranslationNamespaceEnum.FormComponent]: (lang: string) =>
    `src/components/Form/locales/${lang}.json`,
  [TranslationNamespaceEnum.TransferPanel]: (lang: string) =>
    `src/components/Form/panels/TransferPanel/TransferPanel.${lang}.json`,
  [TranslationNamespaceEnum.PricePanel]: (lang: string) =>
    `src/components/Form/panels/PricePanel/locales/${lang}.json`,
  [TranslationNamespaceEnum.Administration]: (lang: string) =>
    `src/admin/administration/locales/${lang}.json`,
  [TranslationNamespaceEnum.ExonnEpost]: (lang: string) =>
    `src/admin/exonn-epost/locales/${lang}.json`,
  [TranslationNamespaceEnum.ExonnInstallations]: (lang: string) =>
    `src/admin/exonn-installations/locales/${lang}.json`,
  [TranslationNamespaceEnum.EpostLetters]: (lang: string) =>
    `src/admin/epost-letters/locales/${lang}.json`,
  [TranslationNamespaceEnum.ManageAttributeValues]: (lang: string) =>
    `src/admin/modules/attribute/routes/edit/tabs/attribute-values/edit.attribute-values.${lang}.json`,
  [TranslationNamespaceEnum.AssignAttributesToVariant]: (lang: string) =>
    `src/admin/modules/product/routes/edit/tabs/variants/edit/tabs/attributes/locales/${lang}.json`,
  [TranslationNamespaceEnum.DateRangeStatusCell]: (lang: string) =>
    `src/components/DateRangeStatusCell/${lang}.json`,
  [TranslationNamespaceEnum.SelectProductTypeModal]: (lang: string) =>
    `src/admin/modals/product/SelectProductType/locales/${lang}.json`,
  [TranslationNamespaceEnum.SelectPriceListsModal]: (lang: string) =>
    `src/admin/modals/product/SelectPriceLists/locales/${lang}.json`,
  [TranslationNamespaceEnum.AssignComponentsToSetModal]: (lang: string) =>
    `src/admin/modals/AssignComponentsToSet/locales/${lang}.json`,
  [TranslationNamespaceEnum.DeleteRecordConfirmationModal]: (lang: string) =>
    `src/admin/modals/DeleteRecordConfirmation/locales/${lang}.json`,
  [TranslationNamespaceEnum.EditAttributeValueModal]: (lang: string) =>
    `src/admin/modals/attribute/EditAttributeValue/locales/${lang}.json`,
  [TranslationNamespaceEnum.CreateAttributeValueModal]: (lang: string) =>
    `src/admin/modals/attribute/CreateAttributeValue/locales/${lang}.json`,
  [TranslationNamespaceEnum.DeleteAttributeValueModal]: (lang: string) =>
    `src/admin/modals/attribute/DeleteAttributeValue/locales/${lang}.json`,
  [TranslationNamespaceEnum.FormContactsPanel]: (lang: string) =>
    `src/components/Form/panels/ContactsPanel/locales/${lang}.json`,
  [TranslationNamespaceEnum.SetComponentList]: (lang: string) =>
    `src/admin/modules/product/components/SetComponents/locales/${lang}.json`,
  [TranslationNamespaceEnum.ProductsImport]: (lang: string) =>
    `src/admin/import/form/${lang}.json`,
  [TranslationNamespaceEnum.Picking]: (lang: string) =>
    `src/admin/picking/Picking/locales/${lang}.json`,
  [TranslationNamespaceEnum.ReturnsIntake]: (lang: string) =>
    `src/admin/returns-intake/ReturnsIntake/locales/${lang}.json`,
  [TranslationNamespaceEnum.ReturnsStatistics]: (lang: string) =>
    `src/admin/returns-statistics/locales/${lang}.json`,
  [TranslationNamespaceEnum.AccountingExport]: (lang: string) =>
    `src/admin/accounting-export/form/${lang}.json`,
  [TranslationNamespaceEnum.EditWarehousePlacesTab]: (lang: string) =>
    `src/admin/modules/warehouse/routes/edit/tabs/storage-scheme/storage-scheme.${lang}.json`,
  [TranslationNamespaceEnum.UpdateRequiredModal]: (lang: string) =>
    `src/admin/modals/UpdateRequiredModal/locales/${lang}.json`,
  [TranslationNamespaceEnum.ScaninfoComponent]: (lang: string) =>
    `src/admin/modules/picklist/forms/picklist/components/Scaninfo/locales/${lang}.json`,
};

export const component: NamespaceTester = (ns: string, lang: string) => {
  // @ts-ignore
  if (namespaceToPathMap?.[ns]) {
    // @ts-ignore
    return namespaceToPathMap[ns](lang);
  }
};
